const hyundai = {
  state: () => ({
    images: {
        sedans: [
          {
            modelName: "Ioniq 6",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq6-25.png"),
            trims: ["SE Standard Range", "SE", "SEL", "Limited"]
          },
          {
            modelName: "Elantra",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/elantra-25.png"),
            trims: ["SE", "SEL Sport", "SEL Convenience", "N Line", "Limited"]
          },
          {
            modelName: "Sonata",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/sonata-25.png"),
            trims: ["SE", "Sport", "Eco", "Limited", "Sport 2.0T", "Limited 2.0T"]
          },
          {
            modelName: "Elantra Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/elantra-hybrid-25.png"),
            trims: ["Blue", "SEL Sport", "Limited"]
          },
          {
            modelName: "Elantra N",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/elantra-n-25.png")
          }
        ],
        suvs: [
          {
            modelName: "Ioniq 9",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq9-26.png"),
            trims: ["S", "SE", "SEL", "Limited", "Calligraphy", "Calligraphy Design"]
          },
          {
            modelName: "Santa Fe",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/santa-fe-25.png"),
            trims: ["SE", "SEL", "XRT", "Limited", "Calligraphy"]
          },
          {
            modelName: "Santa Fe Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/santa-fe-hybrid-25.png"),
            trims: ["SEL", "Limited", "Calligraphy"]
          },
          {
            modelName: "Kona",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/kona-25.png"),
            trims: ["SE", "SEL", "SEL Convenience", "N Line S", "N Line", "Limited"]
          },
          {
            modelName: "Kona Electric",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/kona-electric-25.png"),
            trims: ["SE", "SEL", "N Line", "Limited"]
          },
          {
            modelName: "Santa Cruz",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/santa-cruz-25.png"),
            trims: ["SE", "SEL", "SEL Activity", "XRT", "Limited"]
          },
          {
            modelName: "Tucson",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/tucson-25.png"),
            trims: ["SE", "SEL", "SEL Convenience", "XRT", "Limited"]
          },
          {
            modelName: "Tucson Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/tucson-hybrid-25.png"),
            trims: ["Blue", "SEL Convenience", "N Line", "Limited"]
          },
          {
            modelName: "Tucson Plug-in Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/tucson-plug-in-hybrid-25.png"),
            trims: ["SEL", "Limited"]
          },
          {
            modelName: "Palisade",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/palisade-25.png"),
            trims: ["SE", "SEL", "XRT", "SEL Premium", "Limited", "Calligraphy", "Calligraphy Night"]
          },
          {
            modelName: "Ioniq 5",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq5-25.png"),
            trims: ["SE Standard Range", "SE", "SEL", "XRT", "Limited"]
          },
          {
            modelName: "Ioniq 5 N",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq5-n-25.png")
          },
          {
            modelName: "Venue",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/venue-25.png"),
            trims: ["SE", "SEL", "Limited"]
          },
        ],
        trucks: [],
        evs: [
          {
            modelName: "Ioniq 6",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq6-25.png"),
            trims: ["SE Standard Range", "SE", "SEL", "Limited"]
          },
          {
            modelName: "Sonata",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/sonata-25.png"),
            trims: ["SE", "Sport", "Eco", "Limited", "Sport 2.0T", "Limited 2.0T"]
          },
          {
            modelName: "Elantra Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/elantra-hybrid-25.png"),
            trims: ["Blue", "SEL Sport", "Limited"]
          },
          {
            modelName: "Ioniq 9",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq9-26.png"),
            trims: ["S", "SE", "SEL", "Limited", "Calligraphy", "Calligraphy Design"]
          },
          {
            modelName: "Santa Fe Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/santa-fe-hybrid-25.png"),
            trims: ["SEL", "Limited", "Calligraphy"]
          },
          {
            modelName: "Kona Electric",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/kona-electric-25.png"),
            trims: ["SE", "SEL", "N Line", "Limited"]
          },
          {
            modelName: "Tucson Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/tucson-hybrid-25.png"),
            trims: ["Blue", "SEL Convenience", "N Line", "Limited"]
          },
          {
            modelName: "Tucson Plug-in Hybrid",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/tucson-plug-in-hybrid-25.png"),
            trims: ["SEL", "Limited"]
          },
          {
            modelName: "Ioniq 5",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq5-25.png"),
            trims: ["SE Standard Range", "SE", "SEL", "XRT", "Limited"]
          },
          {
            modelName: "Ioniq 5 N",
            sideView: require("../../../static/images/common-icons/brand-logos/hyundai.png"),
            angleView: require("../../../static/images/carcuts/hyundai/angle-view/ioniq5-n-25.png")
          }
        ],
        lifestyleImages: {
          defaultImage: require("../../../static/images/carcuts/hyundai/lifestyle/ioniq9-alt-26.png"),
          sedanImage: require("../../../static/images/carcuts/hyundai/lifestyle/sonata-25.png"),
          suvImage: require("../../../static/images/carcuts/hyundai/lifestyle/ioniq9-26.png"),
          truckImage: require("../../../static/images/carcuts/hyundai/lifestyle/palisade-26.png")
        },
        videoLink: [
          "https://player.vimeo.com/progressive_redirect/playback/1101606695/rendition/1080p/file.mp4?loc=external&signature=ffec987ac5aba734b6171b5eacecf221067a183bc2dc0ad5e9d2999b481c731a"
        ],
        roundButtons: [
          require("../../../static/images/buttons/round-buttons/hyundai-New.png"), require("../../../static/images/buttons/round-buttons/hyundai-Used.png"), require("../../../static/images/buttons/round-buttons/hyundai-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/hyundai-Worth.png")
        ],
        browseButtons: [
          require("../../../static/images/buttons/browse-buttons/hyundai-new.png"), require("../../../static/images/buttons/browse-buttons/hyundai-used.png"), require("../../../static/images/buttons/browse-buttons/hyundai-service.png"), require("../../../static/images/buttons/browse-buttons/hyundai-specials.png")
        ],
        swoopIcons: [
          require("../../../static/images/buttons/swoop-icons/hyundai01.png"), require("../../../static/images/buttons/swoop-icons/hyundai03.png"), require("../../../static/images/buttons/swoop-icons/hyundai02.png")
        ],
        homeBanners: [
          require("../../../static/images/banners/hyundai/CM-JN-24-Hyundai-Established.jpg"), require("../../../static/images/banners/hyundai/CM-JN-24-Hyundai-Lifestyle.jpg"), require("../../../static/images/banners/hyundai/CM-JN-24-Hyundai-Modern.jpg"), require("../../../static/images/banners/hyundai/CM-JN-24-Hyundai-Playful.jpg")
        ],
        stripBanners: [
          require("../../../static/images/banners/hyundai/SOKAL-SRS-120921-Tucson-Established.jpeg"), require("../../../static/images/banners/hyundai/SOKAL-SRS-120921-Tucson-Lifestyle.jpeg"), require("../../../static/images/banners/hyundai/SOKAL-SRS-120921-Tucson-Modern.jpeg"), require("../../../static/images/banners/hyundai/SOKAL-SRS-120921-Tucson-Playful.jpeg")
        ],
        logoExample: [
          require("../../../static/images/buttons/logos/dd-logo-hyundai.png"),
          require("../../../static/images/buttons/logos/dd-logo-hyundai-w.png")
        ]
      },
    colors: {
      "--primary-color": "#002c5f",
      "--primary-dark": "#000",
      "--primary-light": "#FFF",
      "--secondary-color": "#002c5f",
      "--secondary-dark": "#000",
      "--secondary-light": "#f5f5f5",
    },
    fonts: {
      "--heading-text": "Hyundai-Heavy, 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "Hyundai-Heavy, 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "Hyundai-Regular, 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "Hyundai-Bold, 'Helvetica Neue', Arial, sans-serif"
    }
  })
}


export default hyundai